import React from 'react';

const CapcenterIcon = (props: { fill: string }) => {
	return (
		<svg viewBox="0 0 75 75" version="1.1" aria-label="capcenter icon">
			<g id="coloricon-capcenter" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<path
					d="M41.1127572,2 L75,21.3134558 L75,72 L41.3303865,72 L41.3303865,59.7871798 L58.8930903,59.7871798 L58.8930903,40.1418937 L63.964388,40.1418937 L63.964388,33.8491024 L41.1127572,20.4542553 L41.1127572,2 Z M33.8872428,2 L33.8872428,20.4542553 L11.035612,33.8491024 L11.035612,40.1418937 L16.1069097,40.1418937 L16.1069097,59.7871798 L33.6696135,59.7871798 L33.6696135,72 L-1.42108547e-14,72 L-1.42108547e-14,21.3134558 L33.8872428,2 Z"
					id="Combined-Shape"
					fill={props.fill}
				></path>
			</g>
		</svg>
	);
};

export default CapcenterIcon;